'use client';
import { useIsFetching as useIsFetching$1 } from '@tanstack/react-query';
import { composeQueryFilters } from '../lib/composeQueryFilters.js';
import { useQueryClient } from '../lib/useQueryClient.js';

const useIsFetching = (qraftOptions, schema, args)=>{
    const [filters, queryClientByArg] = args;
    return useIsFetching$1(composeQueryFilters(schema, filters), useQueryClient(qraftOptions, queryClientByArg));
};

export { useIsFetching };
//# sourceMappingURL=useIsFetching.js.map
